import { Permission } from 'legacy/common/types'
import { type AccessControlConfig } from 'legacy/components/AccessControl/accessControl.utils'
import { Flipper } from 'legacy/contexts/flipper/FlipperContext'

export const AccountManagementRetailerAccessControl: AccessControlConfig = {
  permissions: [Permission.ManageUsers],
  warehouseFlippers: [Flipper.RetailerAccountManagementV2],
}
